import { gql } from '@apollo/client';

export const REQUEST_INFO = gql`
  mutation sendRequest($email: String!, $message:String!, $subject:String!) {
    sendRequest(email: $email, message: $message, subject: $subject){
      sent
    }
  }
  `;
